import React from 'react'
import '../../css/Loading.css'

const Loading = () => {
  return (
   
        <div className='container-loader '>
            <div className='loader'></div>
        </div>
    
  )
}

export default Loading

